// import CardHome from "../Component/CardHome"
// import StatsMonths from "../Component/StatsMonths"
// import StatsCard from "../Component/StatsCard"
// import DashboardLayout from "../Layout/DashboardLayout"
// import { useState, useEffect } from 'react'
// import axios from 'axios'
// import { BASE_URL } from '../apiConfig'
// import Cookies from 'js-cookie'
// import { useTranslation } from '../LanguageContext'

// export default function Page() {
//   const { t } = useTranslation()
//   const [stats, setStats] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [dateFrom, setDateFrom] = useState('')
//   const [dateTo, setDateTo] = useState('')
//   const [appliedDateFrom, setAppliedDateFrom] = useState('')
//   const [appliedDateTo, setAppliedDateTo] = useState('')
//   const token = Cookies.get('WEB_SSR')

//   const fetchStats = async (from, to) => {
//     setLoading(true)
//     try {
//       const today = new Date().toISOString().slice(0, 10)
//       if (!from && !to) { from = today; to = today }
//       const params = new URLSearchParams()
//       params.append('date_from', from)
//       params.append('date_to', to)
//       const response = await axios.get(`${BASE_URL}/api/statistics?${params.toString()}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: 'application/json',
//         },
//       })
      
//       if (response.data.success) {
//         setStats(response.data.data)
//       }
//     } catch (error) {
//       console.error('Error fetching dashboard stats:', error)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => { fetchStats(appliedDateFrom, appliedDateTo) }, [appliedDateFrom, appliedDateTo])

//   return (
//     <DashboardLayout>
//       <div className="p-6">
//         <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
//           <div>
//             <h1 className="text-3xl max-lg:text-2xl font-bold text-gray-900 dark:text-gray-50 mb-2">{t('dashboard.title')}</h1>
//             <p className="text-gray-600 dark:text-gray-400">{t('dashboard.subtitle')}</p>
//           </div>
//           <div className="flex items-center gap-2 flex-wrap">
//             <input
//               type="date"
//               value={dateFrom}
//               onChange={(e) => setDateFrom(e.target.value)}
//               className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 outline-none focus:border-[#171717] dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
//             />
//             <input
//               type="date"
//               value={dateTo}
//               onChange={(e) => setDateTo(e.target.value)}
//               className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 outline-none focus:border-[#171717] dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
//             />
//             <button
//               type="button"
//               onClick={() => { setAppliedDateFrom(dateFrom); setAppliedDateTo(dateTo) }}
//               className="rounded-lg bg-[#171717] px-4 py-2 text-xs font-semibold text-white transition hover:bg-gray-800"
//             >
//               {t('charges.filter_btn')}
//             </button>
//             <button
//               type="button"
//               onClick={() => { setDateFrom(''); setDateTo(''); setAppliedDateFrom(''); setAppliedDateTo('') }}
//               className="rounded-lg border border-gray-200 bg-white px-4 py-2 text-xs font-semibold text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
//             >
//               {t('charges.clear')}
//             </button>
//           </div>
//         </div>

//         <div className="mb-8">
//           <StatsMonths data={stats?.summary} financial={stats?.financial} loading={loading} />
//         </div>

//         <div>
//           <div className="mb-8">
//             <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-4">{t('dashboard.high_stock')}</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
//               <CardHome products={stats?.top_products_by_stock} loading={loading} />
//             </div>
//           </div>

//           <div className="mb-8">
//             <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-4">{t('dashboard.low_stock')}</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
//               <CardHome products={stats?.top_products_low_stock} loading={loading} />
//             </div>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-3 xl:gap-6 gap-4">
//             <StatsCard
//               title={t('dashboard.stock_distribution')}
//               data={[
//                 { name: t('dashboard.in_stock'), value: stats?.stock_distribution.in_stock },
//                 { name: t('dashboard.low_stock_label'), value: stats?.stock_distribution.low_stock },
//                 { name: t('dashboard.out_of_stock'), value: stats?.stock_distribution.out_of_stock },
//               ]}
//               colors={['#10b981', '#f59e0b', '#ef4444']}
//             />
            
//             <StatsCard
//               title={t('dashboard.product_types')}
//               data={[
//                 { name: t('dashboard.with_variants'), value: stats?.product_types.with_variants },
//                 { name: t('dashboard.without_variants'), value: stats?.product_types.without_variants },
//               ]}
//               colors={['#3b82f6', '#8b5cf6']}
//             />
//           </div>
//         </div>
//       </div>
//     </DashboardLayout>
//   )
// }


import CardHome from "../Component/CardHome"
import StatsMonths from "../Component/StatsMonths"
import StatsCard from "../Component/StatsCard"
import DashboardLayout from "../Layout/DashboardLayout"
import SelectDate from "../Component/SelectDate"
import DailyProfitChart from "../Component/DailyProfitChart"
import InvoiceCountChart from "../Component/InvoiceCountChart"
import { useState, useEffect } from 'react'
import axios from 'axios'
import { BASE_URL } from '../apiConfig'
import Cookies from 'js-cookie'
import { useTranslation } from '../LanguageContext'

export default function Page() {
  const { t } = useTranslation()
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [dateRange, setDateRange] = useState({
    start_date: '',
    end_date: '',
    type: 'today'
  })
  const token = Cookies.get('WEB_SSR')

  const fetchStats = async (startDate, endDate) => {
    setLoading(true)
    try {
      const params = new URLSearchParams()
      if (startDate) params.append('date_from', startDate)
      if (endDate) params.append('date_to', endDate)
      
      const response = await axios.get(`${BASE_URL}/api/statistics?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      })
      
      if (response.data.success) {
        setStats(response.data.data)
      }
    } catch (error) {
      console.error('Error fetching dashboard stats:', error)
    } finally {
      setLoading(false)
    }
  }

  // Handle date range change from SelectDate component
  const handleDateRangeChange = (range) => {
    setDateRange(range)
    fetchStats(range.start_date, range.end_date)
  }

  // Initial fetch on component mount
  useEffect(() => {
    // Fetch with default date range (last 30 days will be applied by SelectDate)
    // fetchStats('', '')
  }, [])

  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="mb-8 flex gap-3 items-center justify-between">
          <div>
            <h1 className="text-3xl max-lg:text-2xl font-bold text-gray-900 dark:text-gray-50 mb-2">{t('dashboard.title')}</h1>
            <p className="text-gray-600 dark:text-gray-400">{t('dashboard.subtitle')}</p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <SelectDate 
              type="dashboard" 
              onDateRangeChange={handleDateRangeChange} 
            />
          </div>
        </div>

        <div className="mb-8">
          <StatsMonths data={stats?.summary} financial={stats?.financial} loading={loading} />
        </div>

        <div className="mb-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
          <DailyProfitChart />
          <InvoiceCountChart />
        </div>

        <div>
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-4">{t('dashboard.high_stock')}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              <CardHome products={stats?.top_products_by_stock} loading={loading} />
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-4">{t('dashboard.low_stock')}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              <CardHome products={stats?.top_products_low_stock} loading={loading} />
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 xl:gap-6 gap-4">
            <StatsCard
              title={t('dashboard.stock_distribution')}
              data={[
                { name: t('dashboard.in_stock'), value: stats?.stock_distribution?.in_stock || 0 },
                { name: t('dashboard.low_stock_label'), value: stats?.stock_distribution?.low_stock || 0 },
                { name: t('dashboard.out_of_stock'), value: stats?.stock_distribution?.out_of_stock || 0 },
              ]}
              colors={['#10b981', '#f59e0b', '#ef4444']}
            />
            
            <StatsCard
              title={t('dashboard.product_types')}
              data={[
                { name: t('dashboard.with_variants'), value: stats?.product_types?.with_variants || 0 },
                { name: t('dashboard.without_variants'), value: stats?.product_types?.without_variants || 0 },
              ]}
              colors={['#3b82f6', '#8b5cf6']}
            />
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}